import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

const PIPELINE_MONITORING_TRENDS_DEFAULT_FILTERS = {
  dateObject: {
    relative: { periodBehaviour: 'LAST', value: 7, unit: 'DAYS' },
  },
};

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/pipeline-monitoring/trends')({
  validateSearch: zodValidator(withDefaults(schema.PIPELINE_MONITORING_TRENDS, PIPELINE_MONITORING_TRENDS_DEFAULT_FILTERS)),
  beforeLoad: () => getTitleContextSlice('Trends'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
